<template>
  <v-col :cols="12" :sm="12" :md="12">
    <v-alert transition="expand-transition" border="left" text type="error">
      Atenção, está tela serve para fazer a aprovação do recebimento da sua solicitação de materiais, por favor, antes de utilizar o sistema aprove os itens que estejam marcados como "Aguardando conferência do pedido pela Unidade" clicando no botão de Editar!
    </v-alert>

    <Alertas :notificacaoSocket="alertaSocket" :texto="alerta.texto" :tipo="alerta.tipo"></Alertas>

    <DataTable v-show="showSkeletonTable == false" :tableTitle="'Receber Produtos'" :tableHeader="headers" :tableRows="receiveItem" :isEdit="true" :isFinish="false" :isDel="false" :isPrint="false" v-on:datatable-updaterow="modalAtualizar"></DataTable>

    <SkeletonTable v-show="showSkeletonTable == true" :showSkeletonTable="showSkeletonTable"></SkeletonTable>

    <Loading :open="loading" />

    <ModalCustomSize
      :modalSize="modalCustomSize.size"
      :isTheModalOpen="modalCustomSize.isOpen"
      :modalButtonText="modalCustomSize.buttonText"
      :modalFormTitle="modalCustomSize.formTitle"
      :modalType="modalCustomSize.modalType"
      :isLoadingRequestDisable="modalCustomSize.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSize.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSize.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSize.isOpen = false"
      v-on:formmodal-action="atualizar"
    >
      <v-form v-model="isFormValid">
        <v-row>
          <v-col cols="12">
            <AlertasModal :tipo="alertaModal.tipo" :texto="alertaModal.texto"></AlertasModal>
          </v-col>

          <v-col cols="6">
            <v-text-field v-model="modalCustomSize.actualEdit.nomeEndereco" name="nomeEndereco" label="Nome da Unidade" readonly></v-text-field>
          </v-col>

          <v-col cols="6">
            <v-text-field v-model="modalCustomSize.actualEdit.nomeResponsavelUnidade" name="nomeResponsavelUnidade" label="Nome do Responsavel pela Unidade" readonly></v-text-field>
          </v-col>

          <v-col cols="6">
            <v-text-field v-model="modalCustomSize.actualEdit.dataDispensa" name="dataDispensa" label="Data Dispensa" readonly></v-text-field>
          </v-col>

          <v-col cols="6">
            <v-text-field v-model="modalCustomSize.actualEdit.nomeFuncionario" name="nomeFuncionario" label="Responsável pela Dispensa" readonly></v-text-field>
          </v-col>

          <v-expand-transition>
            <v-col cols="12" v-if="verificaSubEstoque">
              <div class="red--text body-1 font-weight-black">• Selecione o estoque para receber os produtos</div>

              <v-autocomplete label="Lista de Subestoques" :items="listaDeSubestoque" v-model="modalCustomSize.actualEdit.numeroSubEstoqueUnidade"></v-autocomplete>
            </v-col>
          </v-expand-transition>

          <v-expand-transition>
            <v-col cols="12">
              <div class="red--text body-1 font-weight-black">• Selecione a caixa somente se precisar editar validade, lote e ou quantidade</div>

              <DatatableReceberItem tableTitle="Lista de Produtos Recebidos" :config="config" :tableHeader="headersModal" :tableRows="modalCustomSize.actualEdit.itensDispensa"></DatatableReceberItem>
            </v-col>
          </v-expand-transition>

          <v-expand-transition>
            <v-col class="d-flex" cols="12">
              <v-select :items="items" label="Aprovação ou Contestação" v-model="selectedStatus" :rules="[rules.required]"></v-select>
            </v-col>
          </v-expand-transition>

          <v-expand-transition>
            <v-col cols="12">
              <v-textarea counter label="Mais detalhes para a contestação" v-if="showTextField" v-model="modalCustomSize.actualEdit.descricaoContestar" :rules="[rules.required]"></v-textarea>
            </v-col>
          </v-expand-transition>

          <v-expand-transition>
            <v-snackbar v-model="snackbar.habilitar" color="error" :multi-line="true" :timeout="-1">
              <div class="text-h5 body-1">{{ snackbar.texto }}</div>

              <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="snackbar.habilitar = false">
                  Fechar
                </v-btn>
              </template>
            </v-snackbar>
          </v-expand-transition>
        </v-row>
      </v-form>
    </ModalCustomSize>

    <AlertaSnackbar :habilitar="alertaSnackbar.mostrar" :texto="alertaSnackbar.texto" :cor="alertaSnackbar.cor" v-on:snack-close="alertaSnackbar.mostrar = false" />
  </v-col>
</template>

<script>
import axios from "../plugins/axios";
import DataTable from "../components/DataTable2";
import DatatableReceberItem from "../components/DatatableReceberItem";
import store from "@/store/index";
import Loading from "../components/Loading.vue";
import ModalCustomSize from "../components/ModalCustomSize";
import SkeletonTable from "../components/SkeletonTable";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";
import AlertaSnackbar from "../components/AlertaSnackbar.vue";

export default {
  components: {
    DataTable,
    Loading,
    ModalCustomSize,
    SkeletonTable,
    Alertas,
    AlertasModal,
    DatatableReceberItem,
    AlertaSnackbar,
  },

  data: () => ({
    alerta: {
      texto: "",
      tipo: "",
    },
    alertaSocket: {
      texto: "",
      tipo: "",
    },
    alertaModal: {
      texto: "",
      tipo: "",
    },

    rules: {
      required: (value) => !!value || "Requer o campo!",
    },

    snackbar: {
      habilitar: false,
      texto: "",
    },

    alertaSnackbar: {
      mostrar: false,
      texto: null,
      cor: "red",
    },

    showTextField: false,
    novaQtdeRecebida: "",

    datatableCheckBox: {
      itemSelecionado: [],
    },

    newNotify: {
      isNewNotify: false,
      text: "",
    },

    items: [
      {
        text: "Aprovar",
        value: 1,
      },
      {
        text: "Contestar",
        value: 3,
      },
    ],

    showSkeletonTable: true,
    selectedStatus: null,
    loading: false,
    isFormValid: false,
    isOpenDialog: false,

    // Cabeçalho da DataTable
    headers: [
      {
        text: "ID Dispensa",
        value: "numeroDispensa",
      },
      {
        text: "Nome Funcionario",
        value: "nomeFuncionario",
      },
      {
        text: "Nome Endereço",
        value: "nomeEndereco",
      },
      {
        text: "Qtde Dispensa",
        value: "quantidadeDispensadas",
      },
      {
        text: "Data da Dispensa",
        value: "dataDispensa",
      },
      {
        text: "Status da Dispensa",
        value: "indicadorStatusDispensa",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],
    headersModal: [
      {
        text: "ID",
        value: "numeroItem",
      },
      {
        text: "Nome Produto",
        value: "nomeItem",
      },
      {
        text: "Editar",
        value: "itemIsEdit",
      },
      {
        text: "Lote",
        value: "lote",
      },
      {
        text: "Validade",
        value: "validade",
      },
      {
        text: "Qtde Dispensada",
        value: "quantidadeDispensadas",
      },
      {
        text: "Qtde Recebida",
        value: "novaQuantidadeRecebida",
      },
    ],

    modalCustomSize: {
      size: "1500",
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isLoadingRequestDisable: false,
      isButtonsVisible: true,
      isButtonsDisabled: false,
      actualEdit: {
        token: store.state.token,
        numeroEndereco: store.state.numeroEndereco,
        numeroDispensa: null,
        nomeEndereco: null,
        nomeResponsavelUnidade: null,
        numeroFuncionario: null,
        nomeFuncionario: null,
        emailFuncionario: null,
        dataDispensa: null,
        indicadorStatus: null,
        descricaoContestar: null,
        quantidadeRecebidaItem: null,
        numeroSubEstoqueUnidade: null,
        numeroHistoricoEntrada: null,
        descricaoTela: "ReceberItem",
        itensDispensa: [],
      },

      updateData: {
        numeroDispensa: null,
        numeroEndereco: store.state.numeroEndereco,
        numeroItemUnidade: null,
        numeroItem: null,
        numeroItemSistema: null,
        numeroUnidade: null,
        nomeItem: null,
        descricaoItem: null,
        validadeItem: null,
        loteItem: null,
        quantidadeEstoqueItem: null,
        quantidadeNovaEstoque: null,
        check: null,
      },
    },

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    //Array populado pela função initialize
    receiveItem: [],
    itensRelacionados: [],
    listaDeSubestoque: [],
    showMateriaisField: null,
    verificaSubEstoque: false,
  }),

  created() {
    this.gerarNovoToken();
  },

  watch: {
    selectedStatus() {
      if (this.selectedStatus == 1) {
        this.modalCustomSize.actualEdit.indicadorStatus = this.selectedStatus;
        this.modalCustomSize.actualEdit.descricaoContestar = null;
        this.showTextField = false;
      } else if (this.selectedStatus == 3) {
        this.modalCustomSize.actualEdit.indicadorStatus = this.selectedStatus;
        this.showTextField = true;
      } else {
        this.showTextField = false;
      }
    },

    isFormValid() {
      this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
    },
  },

  methods: {
    async initialize() {
      try {
        const infoUser = { numeroEndereco: store.state.numeroEndereco };
        let response = await axios.put("receberItem", infoUser, this.config);

        for (let value of response.data) {
          // Mask Date
          value.isEdit = false;

          for (const item of value.itens) {
            item.novaQuantidadeRecebida = item.quantidadeDispensadas;
            item.chipColor = "red";
            item.nomeItemVerificado = false;
            item.statusFamilia = null;
          }
        }

        this.showSkeletonTable = false;
        this.receiveItem = response.data;
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async listaSubestoques() {
      try {
        let responseSubestoque = await axios.put("subestoque", { numeroEndereco: store.state.numeroEndereco }, this.config);

        this.listaDeSubestoque = responseSubestoque.data.map((row) => {
          return {
            value: row.numeroSubestoque,
            text: row.nomeSubestoque,
          };
        });

        if (this.listaDeSubestoque.length > 0) {
          this.showMateriaisField = false;
          this.verificaSubEstoque = true;
          this.listaDeMateriais = [];
        } else {
          this.showMateriaisField = true;
          this.verificaSubEstoque = false;
        }
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      }
    },

    async atualizar() {
      try {
        if (this.modalCustomSize.actualEdit.indicadorStatus == 1) {
          let nomeVerificado = true;

          this.modalCustomSize.actualEdit.itensDispensa.map((itemSelecionado) => {
            if (itemSelecionado.nomeItemVerificado == false) {
              nomeVerificado = false;
            }
          });

          if (nomeVerificado == true || this.selectedStatus == 3) {
            if (confirm("Deseja aprovar o recebimento dos produtos em seu estoque?")) {
              this.modalCustomSize.isLoadingRequestDisable = true;
              await axios.put("atualizarReceberItem", this.modalCustomSize.actualEdit, this.config);
             
              this.emitsendResultAlert = !this.emitsendResultAlert;
              this.modalCustomSize.isOpen = false;

              this.alerta.texto = "Status do Produto atualizado com sucesso!";
              this.alerta.tipo = "sucesso";
            }
          } else {
            this.snackbar.habilitar = true;
            this.snackbar.texto = "ATENÇÃO! Por favor padronize todos os produtos da lista em vermelho para os nomes padrão da sua unidade até que todos fiquem verdes.";
            this.alertaModal.texto = "ATENÇÃO! Por favor padronize todos os produtos da lista em vermelho para os nomes padrão da sua unidade até que todos fiquem verdes.";
            this.alertaModal.tipo = "erro";
          }
        } else if (this.modalCustomSize.actualEdit.indicadorStatus == 3) {
          if (confirm("ATENÇÃO! Você realmente deseja contestar essa nota? Em caso de contestação TODOS os produtos serão devolvidos.")) {
            this.modalCustomSize.isLoadingRequestDisable = true;
            await axios.put("atualizarReceberItem", this.modalCustomSize.actualEdit, this.config, this.numeroDispensa);
            await axios.put("alterarValorNota", this.modalCustomSize.actualEdit, this.config, this.numeroDispensa);
            this.emitsendResultAlert = !this.emitsendResultAlert;
            this.modalCustomSize.isOpen = false;

            this.alerta.texto = "O recebimento do Produto foi recusado com sucesso!";
            this.alerta.tipo = "sucesso";
          }
        }
      } catch (error) {
        console.log(error);
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
        
        if(error.response.data.message.includes("Nota já recebida!")) {
          this.alerta.texto = error.response.data.message;
          this.alerta.tipo = "erro";
          this.modalCustomSize.isOpen = false;
        } else {
          this.alertaModal.texto = error.response.data.message;
          this.alertaModal.tipo = "erro";
          this.modalCustomSize.isOpen = true;
        }
      } finally {
        this.initialize();
        this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
        this.modalCustomSize.isLoadingRequestDisable = false;
      }
    },
    
    async verificarDispensa() {
      try {
        await axios.put("verificadispensa", this.modalCustomSize.actualEdit, this.config);

      } catch (error) {
        console.log(error);
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
        
        if(error.response.data.message.includes("Nota já recebida!")) {
          this.alerta.texto = error.response.data.message;
          this.alerta.tipo = "erro";
          this.modalCustomSize.isOpen = false;
        } else {
          this.alertaModal.texto = error.response.data.message;
          this.alertaModal.tipo = "erro";
          this.modalCustomSize.isOpen = true;
        }
      } finally {
        this.initialize();
        this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
        this.modalCustomSize.isLoadingRequestDisable = false;
      }
    },

    async modalAtualizar(item) {
      this.loading = true;
      try {
        await this.verificarToken();
        await this.listaSubestoques();

        this.modalCustomSize.actualEdit.numeroDispensa = item.numeroDispensa;
        this.modalCustomSize.actualEdit.numeroFuncionario = item.numeroFuncionario;
        this.modalCustomSize.actualEdit.nomeFuncionario = item.nomeFuncionario;
        this.modalCustomSize.actualEdit.emailFuncionario = item.emailFuncionario;
        this.modalCustomSize.actualEdit.nomeResponsavelUnidade = item.nomeResponsavelUnidade;
        this.modalCustomSize.actualEdit.nomeEndereco = item.nomeEndereco;
        this.modalCustomSize.actualEdit.dataDispensa = this.formatStringInBrazilianDateFormat(item.dataDispensa);
        this.modalCustomSize.actualEdit.itensDispensa = item.itens;
        this.modalCustomSize.actualEdit.numeroHistoricoEntrada = item.numeroHistoricoEntrada;

        this.selectedStatus = null;
        this.modalCustomSize.actualEdit.descricaoContestar = null;
        this.modalCustomSize.actualEdit.numeroSubEstoqueUnidade = null;
        this.showTextField = false;
      } catch (error) {
        console.log(error);
      } finally {
        this.modalCustomSize.formTitle = "RECEBER PRODUTOS";
        this.modalCustomSize.buttonText = "CONCLUIR";
        this.modalCustomSize.isOpen = true;
        this.modalCustomSize.isEdit = false;
        this.modalCustomSize.isButtonsDisabled = true;
        this.loading = false;

        await this.verificarDispensa();
      }
    },

    formatStringInBrazilianDateFormat(data) {
      if (data) {
        var ano = data.split("-")[0];
        var mes = data.split("-")[1];
        var dia = data.split("-")[2];
        var dia2 = dia.substring(0, 2);
        // Utilizo o .slice(-2) para garantir o formato com 2 digitos.
        return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
      } else {
        return "Não informado!";
      }
    },

    //#region VERIFICAÇÕES DE TOKENS
    async gerarNovoToken() {
      try {
        const response = await axios.post("/gerartoken", {}, this.config);

        await this.$store.dispatch("setToken", response.data.token);
        await this.$store.dispatch("setAuthenticatedState", true);

        if (response.data.token != this.config.headers["x-auth-token"]) {
          this.config.headers["x-auth-token"] = response.data.token;
        }

        this.initialize();
      } catch (error) {
        console.log(error);
      }
    },

    async verificarToken() {
      try {
        await axios.post("/verifyToken", {}, this.config);
      } catch (error) {
        alert("Tempo de autenticação expirado, por favor realize o login novamente.");

        this.$store.dispatch("logout");
        this.$router.push("/login");
      }
    },
    //#endregion
  },
};
</script>
